// extracted by mini-css-extract-plugin
export default {"paginationContainer":"style_paginationContainer__q5GTx","nextBtn":"style_nextBtn__DKSbS","previousBtn":"style_previousBtn__JXTJC"};